import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../context/context";
import { useKeycloak } from "../../../auth";
import { APP_SHORT_NAME } from "../../utils/constants";
import ApplicationService from "../../services/application-service";

import { styled } from '@mui/system';

interface IStyleProps {
  mainLayout?: boolean;
}

const FooterComponent = (props: IStyleProps) => {
  const Footer = styled('footer')({
    padding: "8px 16px 8px 16px;",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    
    "& small": {
      fontSize: props?.mainLayout ? "14px" : "12px",
      fontWeight: props?.mainLayout ? 400 : 600,
    },
    "& .footerLinks *": {
      marginLeft: 15,
      color: props?.mainLayout ? "var(--kyocera-dark-grey)" : "",
    },
  });
  
  const { config, userProfile } = useContext(AppConfig) || {};

  if (!config || !userProfile) {
    throw new Error("AppConfig context is not properly initialized.");
  }

  const [links, setLinks] = useState<any>({ eulaUrl: "", privacyUrl: "" });
  const { eulaUrl, privacyUrl } = links;
  const [hidePrivacyUrl, setHidePrivacyUrl] = useState(false);
  const { getApplicationLegal } = ApplicationService({
    ...config,
    baseUrl: config.baseAppUrl,
  });
  
  const { t } = useTranslation();

  const requestApplicationLegal = async () => {
    try {
      const response = await getApplicationLegal(APP_SHORT_NAME, userProfile.locale || "en", config.appRegionId);
      setLinks({
        eulaUrl: response?.eulaUrl,
        privacyUrl: response?.privacyUrl,
      })
      setHidePrivacyUrl(response?.hidePrivacyUrl);
      ;
    } catch (e) {
      console.log(e); // Logs the error
    }
  };

  useEffect(() => {
    requestApplicationLegal();
  }, []);

  return (
    <Footer >
      <small>
        © {new Date().getFullYear()} KYOCERA Document Solutions Inc.
      </small>
      <div className="footerLinks">
        {!hidePrivacyUrl && (
          <small>
           
            <a href={privacyUrl} target="_blank" rel="noreferrer">
              {t("footer_privacy_statement")}
            </a>

          </small>
        )}
        <small>
          <a href={eulaUrl} target="_blank" rel="noreferrer">
            {t("footer_license_agreement")}
          </a>
        </small>
      </div>
    </Footer>
  );
};

export default FooterComponent;
